import React, { ReactNode } from 'react';
import { ScrollToTop } from '../DashboardTemplate/ScrollToTop';
import { useStore } from 'zustand';
import { sidebarStore } from '../../store/store';

interface DashboardLayoutProps extends React.InputHTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  sidebarComponent?: ReactNode;
  headerComponent?: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = (props) => {
  const { children, sidebarComponent, headerComponent } = props;

  const store = useStore(sidebarStore);

  return (
    <div className="grid min-h-screen lg:grid-flow-col lg:grid-cols-dashboard lg:grid-rows-dashboard bg-[#F5F6FA]">
      {store.isOpen && (
        <div className="fixed inset-0 z-10 bg-black opacity-50" onClick={() => store.toggle(store.isOpen)}></div>
      )}

      <ScrollToTop />

      {sidebarComponent ? (
        <div className="max-lg:contents lg:row-span-3 lg:min-h-screen lg:w-[250px] lg:shrink-0">
          {sidebarComponent}
        </div>
      ) : null}

      {headerComponent ? headerComponent : undefined}

      <div className="relative min-h-0 min-w-0 overflow-x-hidden overflow-y-auto lg:col-span-2 lg:row-span-2">
        <div className="relative w-full min-w-0 flex-1 px-4 pb-[48px] pt-[24px] md:px-[48px]">{children}</div>
      </div>
    </div>
  );
};

export { DashboardLayout };
